// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';
export const DeviceDesktopSvgIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#000" strokeWidth={3}>
      <rect width={89} height={59} x={5.5} y={14.5} rx={4} />
      <path strokeLinecap="round" d="M34.5 87.25h32" />
      <path strokeLinecap="square" d="M41.208 74.5v12m18-12v12" />
    </g>
  </svg>
);
